export default {
  getCosts(state) {
    return state.costs;
  }
}
